'use strict';

module.exports = '3.8.0';
